const getStoragePromotionDefaultData = () => {
	return {
		modalNotificationHasAlreadyShown: false
	};
};

export default getStoragePromotionDefaultData;
